import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586073ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5 mb-3 font-semibold report-topic" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Video", -1))
const _hoisted_3 = { class: "grid grid-cols-2" }
const _hoisted_4 = { class: "mt-8 mb-3 font-semibold report-topic" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Audio", -1))
const _hoisted_6 = { class: "grid grid-cols-2" }
const _hoisted_7 = { class: "mt-8" }
const _hoisted_8 = { class: "font-semibold mt-8" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, "Other", -1))

import { computed, PropType } from 'vue'
import Checkbox from '@/components/common/Checkbox.vue'

interface ReportProblemFormEmits {
  (e: 'update:modelValue', value: string[]): void
  (e: 'update:other', value: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportProblemForm',
  props: {
  modelValue: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  other: {
    type: String,
    default: '',
  },
},
  emits: ["update:modelValue", "update:other"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const rePortProblemValue = new Map<number, string>([
  [1, "[01] I can't see other(s)"],
  [2, "[02] Other(s) can't see me"],
  [3, "[03] I can't hear other(s)"],
  [4, "[04] Other(s) can't hear me"],
  [5, "[05] My camera or mic doesn't work"],
  [6, '[06] Unstable connection'],
])
const model = computed({
  get: () => props.modelValue,
  set: (value: string[]) => emit('update:modelValue', value),
})
const modelOther = computed({
  get: () => props.other,
  set: (value) => emit('update:other', value),
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SvgIcon, {
        class: "mr-2",
        icon: "eye",
        "inherit-fill": true,
        height: "26"
      }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Checkbox, {
        id: _unref(rePortProblemValue).get(1),
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        value: _unref(rePortProblemValue).get(1),
        label: `I can't see other(s)`
      }, null, 8, ["id", "modelValue", "value", "label"]),
      _createVNode(Checkbox, {
        id: _unref(rePortProblemValue).get(2),
        modelValue: model.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
        value: _unref(rePortProblemValue).get(2),
        label: `Other(s) can't see me`
      }, null, 8, ["id", "modelValue", "value", "label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SvgIcon, {
        class: "mr-2",
        icon: "hearing",
        "inherit-fill": true,
        height: "26"
      }),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Checkbox, {
        id: _unref(rePortProblemValue).get(3),
        modelValue: model.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event)),
        value: _unref(rePortProblemValue).get(3),
        label: `I can't hear other(s)`
      }, null, 8, ["id", "modelValue", "value", "label"]),
      _createVNode(Checkbox, {
        id: _unref(rePortProblemValue).get(4),
        modelValue: model.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model).value = $event)),
        value: _unref(rePortProblemValue).get(4),
        label: `Other(s) can't hear me`
      }, null, 8, ["id", "modelValue", "value", "label"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(Checkbox, {
        id: _unref(rePortProblemValue).get(5),
        modelValue: model.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model).value = $event)),
        value: _unref(rePortProblemValue).get(5),
        label: `My camera or mic doesn't work`
      }, null, 8, ["id", "modelValue", "value"]),
      _createVNode(Checkbox, {
        id: _unref(rePortProblemValue).get(6),
        modelValue: model.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model).value = $event)),
        value: _unref(rePortProblemValue).get(6),
        label: `Unstable connection`
      }, null, 8, ["id", "modelValue", "value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modelOther).value = $event)),
        class: "rounded border border-zinc-300 w-full p-3",
        rows: "2",
        placeholder: "Please specify if any"
      }, null, 512), [
        [_vModelText, modelOther.value]
      ])
    ])
  ]))
}
}

})